import { DishType } from "../constants/enums";

/**
 * Groups consecutive PROTEIN/SAUCE dishes under the preceding BASE/REGULAR dish.
 * @param {Array} dishes - Array of dish objects
 * @returns {Array<{ main: { dish, index }, subDishes: Array<{ dish, index }> }>}
 */
export function groupCustomDishes(dishes = []) {
  const groups = [];
  for (let i = 0; i < dishes.length; i++) {
    const dish = dishes[i];
    if (dish.type === DishType.PROTEIN || dish.type === DishType.SAUCE) {
      if (groups.length > 0) {
        groups[groups.length - 1].subDishes.push({ dish, index: i });
      } else {
        groups.push({ main: { dish, index: i }, subDishes: [] });
      }
    } else {
      groups.push({ main: { dish, index: i }, subDishes: [] });
    }
  }
  return groups;
}
